import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";
import { StringExtensions } from "../../../../_helpers/extensions";
import { useEffect, useRef, useState } from "react";
import { MultiSelectSearcher } from "../../../../_components/Abstractions/MultiSearcher/MultiSearcher";
import { contractorsActions } from "../../../../_store/contractors.slice";

export function WastesKindsMultiSelect({ name, optionSave, required, isUsedContainerRequired = false, isAddressIdRequired = false, usedContainerId, addressId, transactionType, resetOnReadonlyChange, skipFieldsTrack, skipInitLoading = false, includeAllWasteKinds }) {
  const dispatch = useDispatch();
  const { getValues } = useFormContext();
  const wastesEditHelperName = StringExtensions.extractObjectBeforeLastProperty(name);
  const wastesEditHelper = getValues(`${wastesEditHelperName}.wastes`);
  const isFirstRender = useRef(true);

  const [items, setItems] = useState([]);
  const onSearchChange = async(searchTerm) => {
    if (isUsedContainerRequired && !usedContainerId) {
      setItems([]);
      return;
    }

    const params = { searchQuery: searchTerm, usedContainerId, addressId, transactionType, includeAllWasteKinds };
    const response = await dispatch(contractorsActions.searchUsedWastes({ payload: params }));
    setItems(response.payload ?? []);
  };

  useEffect(() => {
    if (isFirstRender.current && skipInitLoading) {
      isFirstRender.current = false;
      return;
    }
    onSearchChange(null);
  }, [addressId, usedContainerId]); // eslint-disable-next-line/react-hooks/exhaustive-deps

  return (
    <>
      <MultiSelectSearcher
        name={name}
        items={items}
        onSearchChange={onSearchChange}
        optionsObject={{ key: "wasteEntityId", value: "displayDescription" }}
        optionSave={(x) => (optionSave ? optionSave(x) : x.wasteId)}
        placeholder="Wybierz towary (gatunki)"
        editHelper={wastesEditHelper}
        required={required}
        readonly={(isUsedContainerRequired && !usedContainerId) || (isAddressIdRequired && !addressId)}
        resetOnReadonlyChange={resetOnReadonlyChange}
        resetOnChange={usedContainerId}
        skipFieldsTrack={skipFieldsTrack}
      />
    </>
  );
}